"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Entrance: the backdrop fades in and the dialog pops up from slightly below.
// Shared by every dialog on this chrome.
const overlayFadeIn = "x18re5ia-B";
const dialogPopIn = "xkf1891-B";
const styles = exports.styles = {
  overlay: {
    position: "xixxii4",
    top: "x13vifvy",
    left: "xu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    right: "x3m8u43",
    bottom: "x1ey2m1c",
    backgroundColor: "x1sag07j",
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    padding: "xomzojh",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    zIndex: "x11uqc5h",
    animationName: "xqcmdr3",
    animationDuration: "xllfotl x1u6grsq",
    animationTimingFunction: "x1debuo4",
    $$css: true
  },
  backdrop: {
    position: "xixxii4",
    top: "x13vifvy",
    left: "xu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    right: "x3m8u43",
    bottom: "x1ey2m1c",
    backgroundColor: "xjbqb8w",
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    cursor: "xt0e3qv",
    $$css: true
  },
  dialog: {
    position: "x1n2onr6",
    zIndex: "x1rozsjd",
    width: "xh8yej3",
    maxWidth: "x1983rqf",
    boxSizing: "x9f619",
    backgroundColor: "xk6p4me",
    borderRadius: "xgqmno8",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    boxShadow: "xe2u5o2",
    paddingTop: "x6gltce",
    paddingBottom: "x163t5y5",
    paddingLeft: "x1vua2ax",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xnywu7s",
    animationName: "xq4bpiy",
    animationDuration: "x1g18oiy x1u6grsq",
    animationTimingFunction: "x1lfcbla",
    animationFillMode: "xskzprw",
    $$css: true
  },
  title: {
    margin: "x1t88kz1",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x1uv3qv7",
    fontWeight: "x1s688f",
    $$css: true
  },
  message: {
    margin: "x1v3k7kg",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    color: "xcdm7ny",
    fontSize: "x1hptrd9",
    lineHeight: "x1jjo3f5",
    $$css: true
  },
  actions: {
    display: "x78zum5",
    justifyContent: "x13a6bvl",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  button: {
    fontFamily: "x1wl88yq",
    fontSize: "x1ksoetq",
    borderRadius: "x1e6avla",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    minHeight: "xsejkeq",
    paddingTop: "x1849fr",
    paddingBottom: "xw47dao",
    paddingLeft: "x1vkna38",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x5myg6p",
    cursor: "x1ypdohk",
    $$css: true
  },
  cancel: {
    color: "x10kmngs",
    backgroundColor: "xjbqb8w",
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  danger: {
    color: "xfungia",
    backgroundColor: "xblpr8d",
    borderColor: "xcacg7e",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  busy: {
    cursor: "xt0e3qv",
    opacity: "x197sbye",
    $$css: true
  }
};